export const parseQueryParams = (
  query: string,
): Record<string, string | string[]> => {
  const q = query.startsWith('?') ? query.substring(1) : query;
  const parts = q.split('&');

  return parts.reduce((acc, part) => {
    const [k, v] = part.split('=');
    if (!k) return acc;

    const key = decodeURIComponent(k);
    const value = decodeURIComponent(v ?? '');

    if (key.endsWith('[]')) {
      const finalKey = key.slice(0, key.length - 2);
      const prevValue = acc[finalKey];
      const finalValue = [
        ...(Array.isArray(prevValue) ? prevValue : []),
        value,
      ];
      return {
        ...acc,
        [finalKey]: finalValue,
      };
    }

    return {
      ...acc,
      [key]: value,
    };
  }, {} as Record<string, string | string[]>);
};
